import { useDispatch, useSelector } from "react-redux";
import { muiMenuStyles } from "../../../constants/muiMenuStyles";
import { ThunkDispatch } from "redux-thunk";
import { useEffect, useRef, useState } from "react";
import { useLoading } from "../../../hooks/useLoading";
import { FaEllipsisV } from "react-icons/fa";
import { DropdownMenu } from "../FrostUI/Dropdown/DropdownMenu";
import { ProgressLoader } from "../Elements";
import { ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { getNavigationUrl } from "../../../common/helpers/navigationHelpers";
import MaterailTable from "../Elements/MaterialTable";
import { tableEmptyMessages } from "../../../constants/messages/tableEmptyMessages";
import { getStatusInfo } from "../TableStatusView";
import HtmlTooltip from "../HtmlTooltilp";
import React from "react";
import { getIsDefaultPaymentSet } from "../getIsDefaultPaymentSet";
import commonNetwork from "../../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { PaymentSetProps } from "../../pages/InsertUpdatePaymentSet";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";
import { getAllPaymentSet } from "../../../store/slices/paymentSetSlice";

const tableData = [

    {
        paymentSetId: 1,
        paymentSetName: "1. Sınıf Müşteri Müşteri Müşteri Müşteri Müşteri Müşteri Müşteri Müşteri Müşteri Müşteri",
        paymentProviderList: ["Paratika Test", "Iyzico Test", "Vakıf Bank Test", "Paratika Test", "Iyzico Test", "Vakıf Bank Test"],
        isDefaultPaymentSet: true,
        status: true
    },
    {
        paymentSetId: 2,
        paymentSetName: "2. Sınıf Müşteri",
        paymentProviderList: ["Paratika Test", "Iyzico Test"],
        isDefaultPaymentSet: false,
        status: false
    },
]

interface PaymentSetTableProps {
    formFilterRef: React.FC<HTMLDivElement> | any;
}

const PaymentSetTable: React.FC<PaymentSetTableProps> = ({ }) => {

    const { firmInformations } = useRecoilValue(tenantState);
    const { licenseKey, taxCode } = firmInformations;

    const classes = muiMenuStyles();

    const thunkdispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const confirmModalRef = useRef<any>();

    const [anchorEl, setAnchorEl] = useState(null);
    const [dropdownMenuId, setDropdownMenuId] = useState<string>("");
    const [dropdownAllValues, setDropdownAllValues] = useState<PaymentSetProps>(); // api bittikten sonratype verilebilir
    const [operationsLoading, setOperationsLoading] = useState<boolean>(false);
    const [posList, setPosList] = useState<any>();

    useEffect(() => {
        handlePosList();
        refreshPaymentSetTable();
    }, []);

    const {
        paymentSetList,
        isFetching,
        isloadingIntegration,
        isFetchComplete
    } = useSelector((state: any) => state.paymentSetList);

    const isopenMenu = Boolean(anchorEl);

    const loading = useLoading(isFetching);

    const handleClickMenu = (event: any, row: any) => {
        setDropdownAllValues(row);
        setDropdownMenuId(row.paymentSetId);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const LinearColor = () => {
        if (operationsLoading || isloadingIntegration) {
            return <ProgressLoader />;
        }
        return null;
    };

    const handlePosList = async () => {
        const data = await commonNetwork.get("/virtualpos");
        if (data.isSuccess) {
            setPosList(data.data.data);
        } else {
            toast.error(data.errorMessage);
        }
    }

    const DropdownMenu = (row: any) => {
        const status = dropdownAllValues?.status;
        return (
            <Menu
                id="customer-operations"
                anchorEl={anchorEl}
                open={isopenMenu}
                onClose={handleClose}
                classes={{
                    paper: classes.paper,
                }}
            >
                <MenuItem component={Link} to={getNavigationUrl(`/odeme-seti-guncelle/` + dropdownAllValues?.paymentSetId)}
                    onClick={() => {
                        setAnchorEl(null);
                    }}
                >
                    <ListItemIcon>
                        <Edit fontSize="small" color="primary" />
                    </ListItemIcon>
                    Düzenle
                </MenuItem>
            </Menu>
        );
    }

    function refreshPaymentSetTable() {
        const apiParams = { licenseKey: licenseKey, taxCode: taxCode };
        const params: any = {
            parameters: {
                paymentSetDesc: "",
                paymentSetStatus: 0,
                isDefaultPaymentSet: 0,
                paymentProvider: 0
            },
            apiParams: apiParams
        }

        thunkdispatch(getAllPaymentSet(params));
    }

    const headCells = [
        {
            id: 'operations',
            numeric: false,
            label: 'İşlemler',
            exceptToExcel: true,
            isRender: true,
            disableSortIcon: true,
            className: "w-[60px]",
            renderRow: (row: any) => {
                return (
                    <div className="flex flex-row justify-around items-center">
                        <a id="report-operations-a"
                            aria-controls={isopenMenu ? 'report-operations' : undefined}
                            aria-haspopup="true"
                            aria-expanded={isopenMenu ? 'true' : undefined}
                            className="cursor-pointer"
                            onClick={(event) => handleClickMenu(event, row)}
                        >
                            <FaEllipsisV
                                className="block sm:block h-3 w-3 font-light	ml-1"
                                aria-hidden="true"
                            />
                        </a>
                        <DropdownMenu />
                    </div>
                )
            }
        },
        {
            id: 'paymentSetId',
            numeric: false,
            label: 'ID',
            isprimary: true,
            className: "min-w-[80px]",
            colWidth: 10, // For excel
            hide: true,
            exceptToExcel: true
        },
        {
            id: 'setDesc',
            numeric: true,
            label: 'Ödeme Kuralı Açıklaması',
            className: "min-w-[180px]",
            maxLength: 70,
            colWidth: 20, // For excel
        },
        {
            numeric: false,
            label: "Ödeme Altyapısı",
            colWidth: 20,
            className: "w-[350px]",
            maxLength: 50,
            isRender: true,
            disabledTooltip: true,
            renderRow: (row: any) => {
                if (!posList) return <span>Yükleniyor...</span>; // Pos listesi yüklenirken

                // Eşleşen bankname'leri al
                const paymentProviderNames = row.setInstalment
                    ? row.setInstalment
                        .map((instalment: any) => {
                            const pos = posList.find((pos: any) => pos.vpid === instalment.vpId);
                            return pos ? pos.vpdisplayname : null;
                        })
                        .filter((name: string | null) => name) // Null değerleri kaldır
                        .join(", ")
                    : "Veri yok";

                // Karakter uzunluğunu kontrol et ve gerekirse kısalt
                const maxLength = 50;
                const truncatedPaymentProviderNames =
                    paymentProviderNames.length > maxLength
                        ? paymentProviderNames.substring(0, maxLength) + "..."
                        : paymentProviderNames;

                return (
                    <HtmlTooltip
                        title={
                            <React.Fragment>
                                <Typography color="inherit">Ödeme Altyapısı</Typography>
                                <label className="font-bold">POS'lar: </label> {paymentProviderNames}
                            </React.Fragment>
                        }
                    >
                        <span>{truncatedPaymentProviderNames}</span>
                    </HtmlTooltip>
                );
            },
        },
        {
            id: 'status',
            numeric: true,
            isRender: true,
            label: 'Durumu',
            className: "w-[80px]",
            colWidth: 20,
            renderRow: (row: any) => (
                <>
                    {getStatusInfo(row.status)}
                </>
            )
        }

    ];

    return (
        <>
            {LinearColor()}
            <MaterailTable
                headerCells={headCells}
                tableData={paymentSetList}
                isRowSelect={false}
                isLoading={loading}
                emptyMessage={isFetchComplete ? tableEmptyMessages.isFilteredDataNotFound : tableEmptyMessages.emptyString}
            />
        </>
    );
}

export default PaymentSetTable;